// @flow

import React, { Component } from 'react';
import { Route, Switch } from 'react-router';

import './App.css';
import Header from '../Header/Header';
import Menu from '../Menu/Menu';
import ContactForm from '../ContactForm/ContactForm';
import PatternGrid from '../PatternGrid/PatternGrid';
import StoresGrid from '../StoresGrid/StoresGrid';
import About from '../About/About';
import Footer from '../Footer/Footer';


export default class App extends Component {
    render() {
        return (
            <div className="ln-app container">
                <Header />
                <Menu />

                <main>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            component={ PatternGrid }/>

                        <Route
                            exact
                            path="/about"
                            component={ About }/>

                        <Route
                            exact
                            path="/contact"
                            component={ ContactForm }/>

                        <Route
                            path='/patterns'
                            component={ PatternGrid } />

                        <Route
                            path='/stores'
                            component={ StoresGrid } />

                    </Switch>
                </main>

                <Footer />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js